function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
/**
 * Persist Faucet mode flags in app.options.faucet.mode.
 */

function normalizeMode() {
  var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var src = mode && _typeof(mode) === 'object' ? mode : {};
  return {
    free: src.free === true || src.free_use === true,
    github: src.github === true,
    twitter: src.twitter === true
  };
}
function readFaucetMode() {
  var _options$faucet;
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return normalizeMode(options === null || options === void 0 || (_options$faucet = options.faucet) === null || _options$faucet === void 0 ? void 0 : _options$faucet.mode);
}
function saveFaucetMode(app) {
  var _app$storage;
  var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var next = normalizeMode(mode);
  if (!app.options) {
    app.options = {};
  }
  if (!app.options.faucet || _typeof(app.options.faucet) !== 'object') {
    app.options.faucet = {};
  }
  app.options.faucet.mode = _objectSpread({}, next);
  if ((_app$storage = app.storage) !== null && _app$storage !== void 0 && _app$storage.saveOptions) {
    app.storage.saveOptions();
  }
  return next;
}
module.exports = {
  readFaucetMode: readFaucetMode,
  saveFaucetMode: saveFaucetMode
};